import React from "react";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";

function RecordStatusFilter({ recordStatus, setRecordStatus }) {
  const handleRecordStatusChange = (event) => {
    setRecordStatus(event.target.value);
  };

  return (
    <FormControl style={{ width: "70%" }}>
      <InputLabel id="record-status-label">Record Status</InputLabel>
      <Select
        labelId="record-status-label"
        id="record-status-select"
        value={recordStatus}
        onChange={handleRecordStatusChange}
      >
        <MenuItem value="Active">Active</MenuItem>
        <MenuItem value="Deleted">Deleted</MenuItem>
      </Select>
    </FormControl>
  );
}

export default RecordStatusFilter;
